import React from 'react'

import { FormEficienciaReprodutiva } from '../form/formEficienciaReprodutiva'
import { Text } from '../../../components'

import * as s from './screenSelector.module.css'

interface ScreenSelectorProps {
    page: string
}

/**
 * 
 * @param page Pagina que deve ser renderizada no index do modulo eficiencia reprodutiva
 * @returns Componente selecionado de acordo com  
 */
export const ScreenSelector: React.FC<ScreenSelectorProps> = ({ page }) => {

    let child = <><Text innerText={page} variation="heading" /></>
    if (page === 'eficiencia-produtiva') child = <FormEficienciaReprodutiva />

    return <div className={s.container}>{child}</div>
}